import { useEffect } from 'react';
import { useIntl } from '@leagueplatform/locales';

export const useDocumentTitle = (title) => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    document.title = formatMessage(
      {
        id: 'DOCUMENT_TITLE',
      },
      {
        title,
      },
    );
  }, [formatMessage, title]);
};
